import api from './api';

const genAIAdminToken = process.env.REACT_APP_GENAI_ADMIN_SECURITY_TOKEN;

const toolManagement = {
  getTools: async (params) =>
    api.get('/genai-admin/tools', {
      headers: {
        'secure-token': genAIAdminToken,
      },
      params: { ...params },
    }),

  getTool: async (id) =>
    api.get(`/genai-admin/tools/${id}`, {
      headers: {
        'secure-token': genAIAdminToken,
      },
    }),

  createTool: async (formData) =>
    api.post('/genai-admin/tools', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'secure-token': genAIAdminToken,
      },
    }),

  updateTool: async (id, formData) =>
    api.put(`/genai-admin/tools/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'secure-token': genAIAdminToken,
      },
    }),

  updateToolStatus: async (id, isActive) =>
    api.patch(
      `/genai-admin/tools/${id}/status`,
      {
        isActive,
      },
      {
        headers: { 'secure-token': genAIAdminToken },
      },
    ),

  deleteTool: async (id) =>
    api.delete(`/genai-admin/tools/${id}`, {
      headers: {
        'secure-token': genAIAdminToken,
      },
    }),

  updateToolMetadata: async (id, metadata) =>
    api.put(`/genai-admin/tools/${id}/metadata`, {
      metadata,
      headers: {
        'secure-token': genAIAdminToken,
      },
    }),

  getAssistants: async () =>
    api.get('/genai-admin/openai/assistants', {
      headers: {
        'secure-token': genAIAdminToken,
      },
    }),
};

export default toolManagement;
